import React from 'react'

const TreatmentInclusionsGrid = ({ TreatmentInclusions }) => {
  return (
    <>
      <div className=" mb-12">
        <div className="grid grid-cols-1 items-center gap-x-10 gap-y-16 px-4 py-2 sm:px-6 lg:grid-cols-2 lg:px-[8%]">
          <div>
            <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Inclusions</h2>
            <p className="mt-4 text-gray-500">
              Key elements of your experience, each carefully chosen to nourish your skin and promote relaxation and good health.
              From the hydrating benefits of various herbal oils to the rejuvenating effects of pressure point stimulation,
              every step is designed to enhance circulation, relieve tension, and leave your skin feeling refreshed and radiant.
              essential elements of your experience, each thoughtfully designed to enhance your skin’s health and overall relaxation.
            </p>
          </div>
          <div className="grid grid-cols-1 grid-rows-1">
            <dl className="grid grid-cols-1 gap-x-6 gap-y-10 sm:grid-cols-3 sm:gap-y-5 lg:gap-x-8">
              {TreatmentInclusions.map((feature) => (
                <div key={feature.id} className="border-t border-gray-200 pt-2">
                  <dt className="font-medium text-gray-900">{feature.title}</dt>
                  <dd className="mt-2 text-sm text-gray-500">{feature.description}</dd>
                </div>
              ))}
            </dl>
          </div>
        </div>
      </div>
    </>
  )
}

export default TreatmentInclusionsGrid